/* eslint-disable react/display-name */
/* eslint-disable max-len */
import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Slider from 'react-slick'

import { TitleOne, TextBodyOne } from '../text'
import DetailServiceProduct from '../detail-service-product'
import icChevronRight from '../../static/images/service-product/ic-chevron-right.svg'
import serviceProductMobileConstant from '../../constants/service-product-mobile'
import detailServiceProduct from '../../constants/detail-service-product'
import { Style } from './index.styles'

const {
  serviceProductMobile,
  serviceProductType: { HF }
} = serviceProductMobileConstant
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  appendDots: dots => (
    <div>
      <ul className="slider-advantage-dot"> {dots} </ul>
    </div>
  ),
  customPaging: () => <div className="slider-advantage-dot-number" />
}
const { detail_service_product } = detailServiceProduct

const onPressItem = (props, item, state) => () => {
  const content = detail_service_product[props.content].find(
    detailServiceProduct => detailServiceProduct.id === item.id
  )
  state.setDetailServiceProduct(content)
  document.body.style.overflow = 'hidden'
  const headerElement = document.getElementById('header')
  const footerElement = document.getElementById('service-fixed')
  const whyMassageElement = document.getElementById('why-massage')
  const contentBody = document.getElementById('content-body')

  if (props.content === HF) {
    const serviceMassageElement = document.getElementById('service-massage')
    serviceMassageElement.style.display = 'none'
  }

  headerElement.style.display = 'none'
  footerElement.style.display = 'none'
  whyMassageElement.style.display = 'none'
  contentBody.style.display = 'none'

  state.setShowDetailProduct(true)
}

const renderButton = (props, item, state) => (
  <div onClick={onPressItem(props, item, state)} className="button-detail">
    <TextBodyOne className="text-button" display="block">
      Lihat Detail
    </TextBodyOne>
    <img src={icChevronRight} alt="halojasa/service-product-icon" />
  </div>
)

const renderProduct = (props, item, state) => (
  <div key={item.id} className="content-product">
    <img
      src={item.image}
      alt={`halojasa/${item.title}`}
      className="image-product"
    />
    <TextBodyOne className="title-product" display="block">
      {item.title}
    </TextBodyOne>
    <TextBodyOne className="subtitle-product" display="block">
      {item.subtitle}
    </TextBodyOne>
    {renderButton(props, item, state)}
  </div>
)

const renderProductList = (props, state) => (
  <Slider {...settings}>
    {serviceProductMobile[props.content].products.map(item =>
      renderProduct(props, item, state)
    )}
  </Slider>
)

const renderSubtitle = props => {
  if (serviceProductMobile[props.content].subtitle) {
    return (
      <TitleOne className="subtitle-service-content" display="block">
        {serviceProductMobile[props.content].subtitle}
      </TitleOne>
    )
  }

  return null
}

const renderContainer = (props, state) => (
  <div
    className="content-service-product"
    style={{
      backgroundImage: `url(${serviceProductMobile[props.content].imageBackground})`
    }}
  >
    <TitleOne className="title-service-content" display="block">
      {serviceProductMobile[props.content].title}
    </TitleOne>
    {renderSubtitle(props)}
    {renderProductList(props, state)}
  </div>
)

const onCloseDetailServiceProduct = (props, state) => () => {
  document.body.style.overflow = 'scroll'
  const headerElement = document.getElementById('header')
  const footerElement = document.getElementById('service-fixed')
  const whyMassageElement = document.getElementById('why-massage')
  const contentBody = document.getElementById('content-body')

  if (props.content === HF) {
    const serviceMassageElement = document.getElementById('service-massage')
    serviceMassageElement.style.display = 'block'
  }

  headerElement.style.display = 'block'
  footerElement.style.display = 'block'
  whyMassageElement.style.display = 'block'
  contentBody.style.display = 'block'

  state.setShowDetailProduct(false)
}

const useServiceProduct = () => {
  const [showDetailProduct, setShowDetailProduct] = useState(false)
  const [detailServiceProduct, setDetailServiceProduct] = useState({})

  return {
    showDetailProduct,
    setShowDetailProduct,
    detailServiceProduct,
    setDetailServiceProduct
  }
}

const ServiceProductMobile = props => {
  const state = useServiceProduct()

  return (
    <>
      <Style>
        <Grid>
          <Row>
            <Col sm={12} xs={12} lg={12} className="container-service-product">
              {renderContainer(props, state)}
            </Col>
          </Row>
        </Grid>
      </Style>
      {state.showDetailProduct && (
        <DetailServiceProduct
          onCloseDetailServiceProduct={onCloseDetailServiceProduct(
            props,
            state
          )}
          detailServiceProduct={state.detailServiceProduct}
        />
      )}
    </>
  )
}

export default ServiceProductMobile
